/* eslint-disable radix */
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { DEACTIVATE_SUBSCRIPTION_PLAN } from 'pages/Vendor/VendorGraphQL';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';

const DeactivatePlanVendorList = ({ rowSelection, resetRowSelection }) => {
  const [showDeleteRecord, setDeleteRecord] = useState(false);

  const toggleDeleteRecord = () => {
    setDeleteRecord(!showDeleteRecord);
  };

  const [deactivateTraderSubscriptionPlans] = useMutation(
    DEACTIVATE_SUBSCRIPTION_PLAN,
    {
      // eslint-disable-next-line no-shadow
      onCompleted: ({ deactivateTraderSubscriptionPlans }) => {
        if (deactivateTraderSubscriptionPlans?.status === 204)
          toast.error(deactivateTraderSubscriptionPlans?.message);
        if (deactivateTraderSubscriptionPlans?.status === 200)
          toast.success(deactivateTraderSubscriptionPlans?.message);
        toggleDeleteRecord();
      },
      onError: ({ graphQLErrors }) => {
        graphQLErrors.map(({ exception }) => {
          toast.error(exception?.message);
          return exception;
        });
        toggleDeleteRecord();
        resetRowSelection();
      },
    },
  );

  const onDeleteConfirmation = async () => {
    try {
      await deactivateTraderSubscriptionPlans({
        variables: {
          traders: rowSelection?.map((key) => parseInt(key)),
        },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  return (
    <>
      {' '}
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Deactivate"
        message="Do you really want to deactivate the plans?"
        cancelButtonLabel="Close"
        addButtonLabel="Deactivate"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />
      <Button
        size="sm"
        outline
        className="p-0 text-decoration-underline border-0 bg-transparent me-2 text-primary"
        color="primary"
        onClick={toggleDeleteRecord}
        disabled={rowSelection.length === 0}
      >
        Deactivate Plans
      </Button>
    </>
  );
};

export default DeactivatePlanVendorList;
